import React, { useEffect, useState } from 'react';
import { SxProps, Theme } from '@mui/system';
import { AutoCompleteTargetNumber } from '../Types/autocomplete.target';
import { MesajTipTanimlari, mesajTipleriData } from './MesajTipleriData';
import Autocomplete from 'src/components/Autocomplete';
import { helper } from 'src/utils/helper';
import { TextField } from 'src/components';
import { AutocompleteChangeDetails, AutocompleteChangeReason, FilterOptionsState } from '@mui/base';
import { AutocompleteOwnerState, AutocompleteRenderInputParams, AutocompleteRenderOptionState } from '@mui/material';

interface IMesajTipAutocompleteProps {
    value?: number;
    disableClearable?: boolean;
    sx?: SxProps<Theme>;
    name?: string;
    label?: string;
    error?: boolean;
    children?: React.ReactNode;
    id?: string;
    required?: boolean;
    onChange?: (e: AutoCompleteTargetNumber) => void;
    onBlur?: (e: AutoCompleteTargetNumber) => void;
    helperText?: string;
    readonly?: boolean;
};

const MesajTipAutocomplete = (props: IMesajTipAutocompleteProps): JSX.Element => {
    const [value, setValue] = useState<MesajTipTanimlari>(new MesajTipTanimlari());

    useEffect(() => {
        if (props?.value > 0 && mesajTipleriData?.length)
            setValue(mesajTipleriData.find(f => f.id === props.value));
    }, [props.value]);

    const filterOptions = (options: MesajTipTanimlari[], state: FilterOptionsState<MesajTipTanimlari>): MesajTipTanimlari[] => {
        return options?.filter(f => helper.UpperCaseAsc(f.label).indexOf(helper.UpperCaseAsc(state.inputValue)) > -1)
    };
    const getOptionLabel = (option: MesajTipTanimlari): string => {
        if (!option.label)
            return "";
        return option.label;
    };
    const renderOption = (props, option: MesajTipTanimlari, state: AutocompleteRenderOptionState, ownerState: AutocompleteOwnerState<MesajTipTanimlari, false, boolean, false, "div">): React.ReactNode => {
        if (!option?.label)
            return "";
        return (
            <li {...props} key={option.label}>
                {option.label}
            </li>
        );
    };
    const onBlur = (event: React.FocusEvent<HTMLDivElement, Element>): void => {
        if (props.onChange)
            props.onChange({ target: { value: value?.id, name: props.name } });
    };
    const onChange = (event: React.SyntheticEvent<Element, Event>, value: MesajTipTanimlari, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<MesajTipTanimlari>): void => {
        setValue(value);
        if (props.onChange)
            props.onChange({ target: { value: value?.id, name: props.name } });
    };
    const renderInput = (params: AutocompleteRenderInputParams): React.ReactNode => {
        return (
            <TextField
                {...params}
                required={props.required}
                label={props.label}
                error={props.error}
                helperText={props.helperText}
            />
        );
    };
    return (
        <Autocomplete
            fullWidth
            readOnly={props.readonly}
            freeSolo={false}
            multiple={false}
            sx={props.sx}
            id={props.id}
            disableClearable={props.disableClearable}
            options={mesajTipleriData}
            value={value?.id > 0 ? value : null}
            isOptionEqualToValue={(o, s) => o?.id === s?.id}
            filterOptions={filterOptions}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            onBlur={onBlur}
            onChange={onChange}
            renderInput={renderInput}
        />
    )
};

export default MesajTipAutocomplete;